import { imagePath } from "../../../utils/urls";
import FileUploadButton from "../../Inputs/FileUploadButton";

const SiteImageHolder: React.FC<any> = ({
  id,
  children,
  setImage,
  image,
  label = "",
  description = "",
  type = "app_icon",
  sClass = "h-16 w-16 overflow-hidden",
  imageBg = "bg-transparent",
  imagePlaceholder = "/sample-logos/icon.svg",
}) => {
  return (
    <div className="w-full mb-6 grid grid-cols-2 gap-8">
      <div className="bg-gray-700 shadow bg-opacity-50 rounded p-4 flex justify-start items-center">
        <div
          className={`w-3/12 h-full flex-shrink-0 flex justify-center items-center rounded-xl ${imageBg} mr-4`}
        >
          <img // eslint-disable-line
            src={image ? imagePath(image) : imagePlaceholder}
            className={sClass}
            alt="Project Logo"
            style={{ objectFit: "contain" }}
          />
        </div>

        <div className="rounded-md ">
          <h5 className="font-medium text-sm">{label}</h5>
          <p className="text-gray-400 text-xs">{description}</p>
          <div className="flex items-center mt-4">
            <FileUploadButton
              id={id}
              onComplete={setImage}
              fileType={type}
              text={image ? "Change Image" : "Choose Image"}
            />
            {image && (
              <button
                type="button"
                onClick={() => setImage(null)}
                className="text-xs text-gray-500 mr-3 ml-3 opacity-50 hover:opacity-100 cursor-pointer transition ease-in-out duration-150 focus:outline-none"
              >
                Remove
              </button>
            )}
          </div>
        </div>
      </div>
      <div className="text-left text-xs text-gray-400 font-light leading-5 flex flex-col items-start justify-center pl-10">
        <h6 className="text-xs text-white font-medium">Requirements:</h6>
        {children}
      </div>
    </div>
  );
};

export default SiteImageHolder;
